import React, { useEffect, useState, useCallback } from 'react'
import AdminLayout from '../../layouts/AdminLayout'
import apiClient from '@services/api/client'

// ─── Config par type ───────────────────────────────────────────────────────
const TYPE_CFG = {
  user_login:       { label: 'Connexion',     bg: 'bg-blue-100',    text: 'text-blue-700',    iconBg: 'bg-blue-50',    iconColor: 'text-blue-600',    d: 'M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1' },
  user_logout:      { label: 'Déconnexion',   bg: 'bg-orange-100',  text: 'text-orange-700',  iconBg: 'bg-orange-50',  iconColor: 'text-orange-600',  d: 'M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1' },
  user_created:     { label: 'Inscription',   bg: 'bg-cyan-100',    text: 'text-cyan-700',    iconBg: 'bg-cyan-50',    iconColor: 'text-cyan-600',    d: 'M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z' },
  user_archived:    { label: 'Archivage',     bg: 'bg-yellow-100',  text: 'text-yellow-700',  iconBg: 'bg-yellow-50',  iconColor: 'text-yellow-600',  d: 'M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4' },
  user_deleted:     { label: 'Suppression',   bg: 'bg-red-100',     text: 'text-red-700',     iconBg: 'bg-red-50',     iconColor: 'text-red-600',     d: 'M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16' },
  post_created:     { label: 'Publication',   bg: 'bg-green-100',   text: 'text-green-700',   iconBg: 'bg-green-50',   iconColor: 'text-green-600',   d: 'M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z' },
  post_updated:     { label: 'Modification',  bg: 'bg-amber-100',   text: 'text-amber-700',   iconBg: 'bg-amber-50',   iconColor: 'text-amber-600',   d: 'M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15' },
  post_deleted:     { label: 'Suppression',   bg: 'bg-red-100',     text: 'text-red-700',     iconBg: 'bg-red-50',     iconColor: 'text-red-600',     d: 'M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16' },
  post_approved:    { label: 'Approuvé',      bg: 'bg-emerald-100', text: 'text-emerald-700', iconBg: 'bg-emerald-50', iconColor: 'text-emerald-600', d: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z' },
  post_rejected:    { label: 'Refusé',        bg: 'bg-rose-100',    text: 'text-rose-700',    iconBg: 'bg-rose-50',    iconColor: 'text-rose-600',    d: 'M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z' },
  role_assigned:    { label: 'Rôle',          bg: 'bg-purple-100',  text: 'text-purple-700',  iconBg: 'bg-purple-50',  iconColor: 'text-purple-600',  d: 'M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z' },
  content_reported: { label: 'Signalement',   bg: 'bg-red-100',     text: 'text-red-700',     iconBg: 'bg-red-50',     iconColor: 'text-red-600',     d: 'M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z' },
  comment_added:    { label: 'Commentaire',   bg: 'bg-blue-100',    text: 'text-blue-700',    iconBg: 'bg-blue-50',    iconColor: 'text-blue-600',    d: 'M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z' },
  like:             { label: "J'aime",        bg: 'bg-pink-100',    text: 'text-pink-700',    iconBg: 'bg-pink-50',    iconColor: 'text-pink-600',    d: 'M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z' },
  payment_received: { label: 'Paiement',      bg: 'bg-green-100',   text: 'text-green-700',   iconBg: 'bg-green-50',   iconColor: 'text-green-600',   d: 'M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z' },
}
const LEVEL_CFG = {
  info:    { bg: 'bg-blue-100',   text: 'text-blue-700'   },
  warning: { bg: 'bg-yellow-100', text: 'text-yellow-700' },
  error:   { bg: 'bg-red-100',    text: 'text-red-700'    },
  debug:   { bg: 'bg-gray-100',   text: 'text-gray-600'   },
}
const getCfg   = (type)  => TYPE_CFG[type]  || { label: type || 'Info',    bg: 'bg-gray-100',  text: 'text-gray-600',  iconBg: 'bg-gray-100', iconColor: 'text-gray-500', d: 'M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z' }
const getLvlCfg = (level) => LEVEL_CFG[level] || { bg: 'bg-gray-100', text: 'text-gray-600' }

// ─── Page ──────────────────────────────────────────────────────────────────
const AdminActivitiesPage = () => {
  const [logs,        setLogs       ] = useState([])
  const [stats,       setStats      ] = useState({ total: 0, by_level: {}, by_type: {} })
  const [loading,     setLoading    ] = useState(true)
  const [refreshing,  setRefreshing ] = useState(false)

  // Filtres
  const [filterLevel, setFilterLevel] = useState('')
  const [filterType,  setFilterType ] = useState('')
  const [searchTerm,  setSearchTerm ] = useState('')

  // Pagination serveur
  const [currentPage, setCurrentPage] = useState(1)
  const [lastPage,    setLastPage   ] = useState(1)
  const [total,       setTotal      ] = useState(0)
  const PER_PAGE = 20

  // ── Chargement des logs (pagination + filtres côté serveur) ──────────────
  const loadLogs = useCallback(async (page = 1, silent = false) => {
    if (!silent) setLoading(true)
    else setRefreshing(true)
    try {
      const params = { page }
      if (filterLevel) params.level = filterLevel
      if (filterType)  params.type  = filterType

      const res = await apiClient.get('/logs', { params })
      if (res?.success !== false) {
        let data = res.data || []
        // Filtre recherche côté client (le backend ne supporte pas search)
        if (searchTerm) {
          const q = searchTerm.toLowerCase()
          data = data.filter(l =>
            l.message?.toLowerCase().includes(q) ||
            l.type?.toLowerCase().includes(q) ||
            l.user?.nom?.toLowerCase().includes(q) ||
            l.user?.prenom?.toLowerCase().includes(q) ||
            l.user?.email?.toLowerCase().includes(q)
          )
        }
        setLogs(data)
        setTotal(res.total ?? data.length)
        setCurrentPage(res.meta?.current_page ?? page)
        setLastPage(res.meta?.last_page ?? 1)
      }
    } catch (e) {
      console.error('Erreur chargement logs:', e)
    } finally {
      setLoading(false)
      setRefreshing(false)
    }
  }, [filterLevel, filterType, searchTerm])

  // ── Chargement des stats ──────────────────────────────────────────────────
  const loadStats = useCallback(async () => {
    try {
      const res = await apiClient.get('/logs/stats')
      if (res?.success !== false) setStats(res.data || { total: 0, by_level: {}, by_type: {} })
    } catch (e) {
      console.error('Erreur chargement stats:', e)
    }
  }, [])

  // ── Effets ────────────────────────────────────────────────────────────────
  useEffect(() => {
    loadLogs(1)
    loadStats()
  }, [filterLevel, filterType])                    // recharge quand filtre change

  useEffect(() => {
    const delay = setTimeout(() => loadLogs(1), 400)  // debounce recherche
    return () => clearTimeout(delay)
  }, [searchTerm])

  // ── Supprimer tous les logs ───────────────────────────────────────────────
  const handleClearAll = async () => {
    if (!window.confirm('Supprimer tous les logs ? Cette action est irréversible.')) return
    try {
      await apiClient.delete('/logs')
      loadLogs(1, true)
      loadStats()
    } catch (e) {
      console.error('Erreur suppression logs:', e)
    }
  }

  // ── Carte stats ───────────────────────────────────────────────────────────
  const statCards = [
    { label: 'Total',         value: stats.total,              filter: '',         filterKey: 'level', iconBg: 'bg-blue-50',   iconColor: 'text-blue-600',   numColor: 'text-gray-800',    d: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z' },
    { label: 'Info',          value: stats.by_level?.info    ?? 0, filter: 'info',    filterKey: 'level', iconBg: 'bg-blue-50',   iconColor: 'text-blue-600',   numColor: 'text-blue-600',    d: 'M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z' },
    { label: 'Avertissement', value: stats.by_level?.warning ?? 0, filter: 'warning', filterKey: 'level', iconBg: 'bg-yellow-50', iconColor: 'text-yellow-600', numColor: 'text-yellow-600',  d: 'M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z' },
    { label: 'Erreur',        value: stats.by_level?.error   ?? 0, filter: 'error',   filterKey: 'level', iconBg: 'bg-red-50',    iconColor: 'text-red-600',    numColor: 'text-red-600',     d: 'M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z' },
    { label: 'Connexions',    value: stats.by_type?.user_login  ?? 0, filter: 'user_login',  filterKey: 'type', iconBg: 'bg-green-50',  iconColor: 'text-green-600',  numColor: 'text-green-600',   d: 'M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1' },
    { label: 'Publications',  value: stats.by_type?.post_created ?? 0, filter: 'post_created', filterKey: 'type', iconBg: 'bg-purple-50', iconColor: 'text-purple-600', numColor: 'text-purple-600',  d: 'M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z' },
  ]

  // ── Pagination ────────────────────────────────────────────────────────────
  const goToPage = (page) => {
    if (page < 1 || page > lastPage) return
    loadLogs(page, true)
  }

  const startItem = (currentPage - 1) * PER_PAGE + 1
  const endItem   = Math.min(currentPage * PER_PAGE, total)

  // ── Rendu ─────────────────────────────────────────────────────────────────
  return (
    <AdminLayout>
      <div className="space-y-6 mt-10">

        {/* ── Header ── */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-8">
          <div className="flex items-center justify-between flex-wrap gap-4">
            <div>
              <h1 className="text-3xl font-semibold text-gray-800">Journal d'Activités</h1>
              <p className="text-gray-500 mt-2 flex items-center gap-2">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                </svg>
                Historique complet des actions système — connecté en temps réel
              </p>
            </div>
            <div className="flex items-center gap-3">
              <button
                onClick={() => { loadLogs(currentPage, true); loadStats() }}
                disabled={refreshing}
                className="flex items-center gap-2 px-5 py-2.5 border border-gray-200 rounded-lg hover:bg-gray-50 transition-all text-gray-700 font-medium disabled:opacity-50"
              >
                <svg className={`w-4 h-4 ${refreshing ? 'animate-spin' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
                Actualiser
              </button>
              <button
                onClick={handleClearAll}
                className="flex items-center gap-2 px-5 py-2.5 border border-red-200 text-red-600 rounded-lg hover:bg-red-50 transition-all font-medium"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
                Vider les logs
              </button>
              <button
                onClick={() => { loadLogs(1); loadStats() }}
                className="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-[#D4AF37] to-[#c09d2a] text-white rounded-lg hover:shadow-lg transition-all font-medium"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
                Recharger
              </button>
            </div>
          </div>
        </div>

        {/* ── Stats ── */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-5">
          {statCards.map((s) => {
            const isActive = s.filterKey === 'level' ? filterLevel === s.filter : filterType === s.filter
            return (
              <div
                key={s.label}
                onClick={() => {
                  if (s.filterKey === 'level') {
                    setFilterLevel(isActive ? '' : s.filter)
                    setFilterType('')
                  } else {
                    setFilterType(isActive ? '' : s.filter)
                    setFilterLevel('')
                  }
                  setCurrentPage(1)
                }}
                className={`bg-white rounded-xl shadow-sm p-6 border cursor-pointer hover:shadow-md transition-shadow ${
                  isActive ? 'border-[#D4AF37] ring-2 ring-[#D4AF37]/30' : 'border-gray-100'
                }`}
              >
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm text-gray-500 font-medium mb-1">{s.label}</p>
                    <p className={`text-2xl font-bold ${s.numColor}`}>{s.value}</p>
                  </div>
                  <div className={`w-12 h-12 ${s.iconBg} rounded-lg flex items-center justify-center`}>
                    <svg className={`w-6 h-6 ${s.iconColor}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={s.d} />
                    </svg>
                  </div>
                </div>
              </div>
            )
          })}
        </div>

        {/* ── Filtres ── */}
        <div className="bg-white rounded-xl shadow-sm p-6 border border-gray-100">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="relative md:col-span-1">
              <svg className="absolute left-3 top-3.5 w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
              <input
                type="text"
                placeholder="Rechercher (message, utilisateur, type)..."
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
                className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-[#001F3F] focus:border-transparent transition-all"
              />
            </div>

            <select
              value={filterLevel}
              onChange={e => { setFilterLevel(e.target.value); setFilterType(''); setCurrentPage(1) }}
              className="px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-[#001F3F] focus:border-transparent bg-white transition-all"
            >
              <option value="">Tous les niveaux</option>
              <option value="info">ℹ️ Info</option>
              <option value="warning">⚠️ Avertissement</option>
              <option value="error">❌ Erreur</option>
              <option value="debug">🔧 Debug</option>
            </select>

            <select
              value={filterType}
              onChange={e => { setFilterType(e.target.value); setFilterLevel(''); setCurrentPage(1) }}
              className="px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-[#001F3F] focus:border-transparent bg-white transition-all"
            >
              <option value="">Tous les types</option>
              <option value="user_login">Connexions</option>
              <option value="user_logout">Déconnexions</option>
              <option value="user_created">Inscriptions</option>
              <option value="user_archived">Archivages</option>
              <option value="user_deleted">Suppressions user</option>
              <option value="post_created">Publications créées</option>
              <option value="post_updated">Publications modifiées</option>
              <option value="post_deleted">Publications supprimées</option>
              <option value="post_approved">Approbations</option>
              <option value="post_rejected">Rejets</option>
              <option value="role_assigned">Attribution rôle</option>
              <option value="content_reported">Signalements</option>
              <option value="comment_added">Commentaires</option>
            </select>
          </div>

          {/* Filtres actifs */}
          {(filterLevel || filterType || searchTerm) && (
            <div className="flex items-center gap-2 mt-4 flex-wrap">
              <span className="text-sm font-medium text-blue-800">Filtres actifs :</span>
              {filterLevel && (
                <span className="inline-flex items-center gap-1 px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-sm font-medium">
                  Niveau : {filterLevel}
                  <button onClick={() => setFilterLevel('')}><svg className="w-3.5 h-3.5 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12"/></svg></button>
                </span>
              )}
              {filterType && (
                <span className="inline-flex items-center gap-1 px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-sm font-medium">
                  Type : {filterType}
                  <button onClick={() => setFilterType('')}><svg className="w-3.5 h-3.5 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12"/></svg></button>
                </span>
              )}
              {searchTerm && (
                <span className="inline-flex items-center gap-1 px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-sm font-medium">
                  "{searchTerm}"
                  <button onClick={() => setSearchTerm('')}><svg className="w-3.5 h-3.5 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12"/></svg></button>
                </span>
              )}
              <button
                onClick={() => { setFilterLevel(''); setFilterType(''); setSearchTerm('') }}
                className="text-sm text-blue-600 hover:text-blue-800 font-medium ml-2"
              >
                Réinitialiser tout
              </button>
            </div>
          )}
        </div>

        {/* ── Table ── */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
          <div className="px-6 py-4 border-b border-gray-100">
            <div className="flex items-center justify-between">
              <h2 className="text-lg font-semibold text-gray-800">Historique des activités</h2>
              <span className="text-sm text-gray-500">
                {total} entrée{total > 1 ? 's' : ''} en base
                {refreshing && <span className="ml-2 text-xs text-[#D4AF37]">• Actualisation…</span>}
              </span>
            </div>
          </div>

          <div className="overflow-x-auto">
            {loading ? (
              <div className="flex items-center justify-center py-20 text-gray-400">
                <div className="flex flex-col items-center gap-3">
                  <svg className="w-8 h-8 animate-spin text-[#D4AF37]" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
                  </svg>
                  <span className="text-sm">Chargement depuis la base de données…</span>
                </div>
              </div>
            ) : (
              <table className="w-full">
                <thead className="bg-gray-50 border-b border-gray-100">
                  <tr>
                    <th className="text-left px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">#</th>
                    <th className="text-left px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Type</th>
                    <th className="text-left px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Utilisateur</th>
                    <th className="text-left px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Message</th>
                    <th className="text-left px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Niveau</th>
                    <th className="text-left px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">IP</th>
                    <th className="text-left px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {logs.length === 0 ? (
                    <tr>
                      <td colSpan={7} className="text-center py-16 text-gray-500">
                        <div className="flex flex-col items-center gap-3">
                          <svg className="w-16 h-16 text-gray-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                          </svg>
                          <p className="text-lg font-medium">Aucun log trouvé</p>
                          <p className="text-sm text-gray-400">Essayez de modifier vos filtres</p>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    logs.map((log, idx) => {
                      const typeCfg = getCfg(log.type)
                      const lvlCfg  = getLvlCfg(log.level)
                      const userName = log.user
                        ? `${log.user.prenom || ''} ${log.user.nom || ''}`.trim() || log.user.email
                        : '—'
                      return (
                        <tr key={log.id} className="hover:bg-gray-50 transition-colors">
                          {/* Numéro */}
                          <td className="px-6 py-4">
                            <span className="text-xs text-gray-400 font-mono">
                              {startItem + idx}
                            </span>
                          </td>

                          {/* Type */}
                          <td className="px-6 py-4">
                            <div className="flex items-center gap-2.5">
                              <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 ${typeCfg.iconBg}`}>
                                <svg className={`w-4 h-4 ${typeCfg.iconColor}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={typeCfg.d} />
                                </svg>
                              </div>
                              <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${typeCfg.bg} ${typeCfg.text} whitespace-nowrap`}>
                                {typeCfg.label}
                              </span>
                            </div>
                          </td>

                          {/* Utilisateur */}
                          <td className="px-6 py-4">
                            <p className="text-sm font-medium text-gray-700 truncate max-w-[140px]">{userName}</p>
                            {log.user?.email && (
                              <p className="text-xs text-gray-400 truncate max-w-[140px]">{log.user.email}</p>
                            )}
                          </td>

                          {/* Message */}
                          <td className="px-6 py-4">
                            <p className="text-sm text-gray-600 max-w-xs truncate" title={log.message}>
                              {log.message || '—'}
                            </p>
                            {log.context && Object.keys(log.context).length > 0 && (
                              <p className="text-xs text-gray-400 mt-0.5 truncate max-w-xs">
                                {Object.entries(log.context).slice(0, 2).map(([k,v]) => `${k}: ${v}`).join(' · ')}
                              </p>
                            )}
                          </td>

                          {/* Niveau */}
                          <td className="px-6 py-4">
                            <span className={`px-3 py-1 rounded-full text-xs font-medium capitalize ${lvlCfg.bg} ${lvlCfg.text}`}>
                              {log.level || '—'}
                            </span>
                          </td>

                          {/* IP */}
                          <td className="px-6 py-4">
                            <span className="text-xs font-mono text-gray-500">{log.ip_address || '—'}</span>
                          </td>

                          {/* Date */}
                          <td className="px-6 py-4 text-gray-600 text-sm whitespace-nowrap">
                            {log.created_at
                              ? new Date(log.created_at).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short', year: 'numeric' })
                              : '—'}
                            <div className="text-xs text-gray-400 mt-0.5">
                              {log.created_at
                                ? new Date(log.created_at).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', second: '2-digit' })
                                : ''}
                            </div>
                          </td>
                        </tr>
                      )
                    })
                  )}
                </tbody>
              </table>
            )}
          </div>

          {/* ── Pagination serveur ── */}
          {!loading && lastPage > 1 && (
            <div className="px-6 py-4 border-t border-gray-100 bg-gray-50">
              <div className="flex items-center justify-between flex-wrap gap-4">
                <div className="text-sm text-gray-600">
                  Affichage de <span className="font-semibold">{startItem}</span> à{' '}
                  <span className="font-semibold">{endItem}</span> sur{' '}
                  <span className="font-semibold">{total}</span> entrées
                </div>
                <div className="flex items-center gap-2">
                  <button
                    onClick={() => goToPage(currentPage - 1)}
                    disabled={currentPage === 1}
                    className="px-3 py-2 border border-gray-300 rounded-lg hover:bg-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                    </svg>
                  </button>

                  <div className="flex items-center gap-1">
                    {(() => {
                      const pages = []
                      if (lastPage <= 7) {
                        for (let i = 1; i <= lastPage; i++) pages.push(i)
                      } else {
                        pages.push(1)
                        let start = Math.max(2, currentPage - 1)
                        let end   = Math.min(lastPage - 1, currentPage + 1)
                        if (currentPage <= 3)              { start = 2; end = 5 }
                        if (currentPage >= lastPage - 2)   { start = lastPage - 4; end = lastPage - 1 }
                        if (start > 2) pages.push('...')
                        for (let i = start; i <= end; i++) pages.push(i)
                        if (end < lastPage - 1) pages.push('...')
                        pages.push(lastPage)
                      }
                      return pages.map((page, i) =>
                        page === '...'
                          ? <span key={`e${i}`} className="px-3 py-2 text-gray-400">...</span>
                          : (
                            <button key={page} onClick={() => goToPage(page)}
                              className={`px-4 py-2 rounded-lg transition-colors ${
                                currentPage === page
                                  ? 'bg-[#D4AF37] text-white font-semibold'
                                  : 'bg-white border border-gray-300 hover:bg-gray-50 text-gray-700'
                              }`}>
                              {page}
                            </button>
                          )
                      )
                    })()}
                  </div>

                  <button
                    onClick={() => goToPage(currentPage + 1)}
                    disabled={currentPage === lastPage}
                    className="px-3 py-2 border border-gray-300 rounded-lg hover:bg-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>

      </div>
    </AdminLayout>
  )
}

export default AdminActivitiesPage
